import { render, staticRenderFns } from "./ConfigRecordDialog.vue?vue&type=template&id=235f891a&scoped=true&"
import script from "./ConfigRecordDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f891a",
  null
  
)

export default component.exports